module.exports = __webpack_public_path__ + "static/media/star_F50D0D.8aaea49b.svg";